// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgForbiddenIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m7 10c0 1.39-.41 2.68-1.11 3.77L8.23 6.11C9.32 5.41 10.61 5 12 5c3.86 0 7 3.14 7 7M5 12c0-1.39.41-2.68 1.11-3.77l9.66 9.66C14.68 18.59 13.39 19 12 19c-3.86 0-7-3.14-7-7" />
  </Icon>
);
export default SvgForbiddenIcon;
SvgForbiddenIcon.displayName = 'SvgForbiddenIcon';
